export enum AUTH {
  ACCESS_TOKEN = '@wazai:access-token',
  REFRESH_TOKEN = '@wazai:refresh-token',
  TEAM_ID = '@wazai:teamId',
};
